
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...tag]",
      function () {
        return require("private-next-pages/[...tag].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...tag]"])
      });
    }
  